import "./LoadingIndicator.less";

import * as React from "react";

const LoadingIndicator = () => {
	return <div className="loading-indicator" />;
};

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/LoadingIndicator.js